import { parseISODate, localTodayISO } from './packageItinerary';

/**
 * A hotel offer may carry suggested dates, but a supplier handoff must never
 * invent a stay (e.g. today + four nights). Let the traveler provide dates.
 */
export function verifyHotelStay(checkin, checkout, now = new Date()) {
  const arrival = parseISODate(checkin);
  const departure = parseISODate(checkout);
  if (!arrival || !departure) return { valid: false, reason: 'missing_or_invalid' };
  if (checkin < localTodayISO(now)) return { valid: false, reason: 'past_date' };
  if (checkout <= checkin) return { valid: false, reason: 'invalid_order' };
  const nights = Math.round((departure.getTime() - arrival.getTime()) / 86400000);
  if (nights < 1 || nights > 45) return { valid: false, reason: 'stay_too_long' };
  return { valid: true, checkin, checkout, nights };
}
